// extracted by mini-css-extract-plugin
module.exports = {"container":"spot-results-info-text-desktop_container__ZvXzf","text":"spot-results-info-text-desktop_text___NyCg"};